import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { Button } from "reactstrap";

import Logo from "~/assets/images/login/login-logo.svg";

import security from "~/services/security";


const RegisterConfirmation = ()=> {

  const { token } = useParams();

  const [status  , setStatus]  = useState({loading: true});
  const [message , setMessage] = useState("");
  const [errors  , setErrors]  = useState({});

  useEffect(()=> {
     security.registerConfirmation(token)
      .then((message)=> { setStatus(true);  setMessage(message); })
      .catch((err)=>    { setStatus(false); setErrors(err); });
  }, []);

  if(status.loading) return null;

  return (
    <div className="login-card">
      <div>

        <Link to={"/login"} className="logo"> <img src={Logo} /> </Link>

        <div className="text-center m-t-50">

          { errors.generalError && <p className='text-danger'>{ errors.generalError } </p> }

          <div className='m-t-30 mb-5'>
            { status && <h5 style={{color: 'grey'}}> { message } </h5> }
          </div>

          <Button  color="primary" style={{width: 200}}>
            <Link to="/login" style={{color: "white"}}> Login Now </Link>
          </Button>

        </div>
      </div>
    </div>
  );
};

export default RegisterConfirmation;
